import React, {Fragment, useContext, useEffect, useState} from 'react'
import {Store} from "../../../app/stores/store-root";
import {AgentsList} from "./agents-list";
import {observer} from "mobx-react-lite";
import {useHistory} from 'react-router-dom';
import {API} from 'aws-amplify'

export const AgentsDashboard = () => {
    const store = useContext(Store);
    const {loadAgents, isLoadingInitial, agentRegistry} = store.Agents;
    const [error, setError] = useState(undefined);
    const history = useHistory();

    useEffect(() => {
        const load = async () => await loadAgents();


        load().catch(e => {
            console.log('agentsDashboard.tsx : problems loading agents data :  ', error);
            setError(e)
        })

    }, [loadAgents])

    const createRecrod = () => {
        const initData = {
            body: {
                Name: "yyyyy xxxxx From POstman",
                email: "mokhal@eeeeee.com",
                phone: "++44777777777",
                address: "28 Hartland Road, UB82PX"
            }
        }
        API.post('backend', '/users', initData).then(response => console.log(response)).catch(error => console.log(error));
    }
    //loading error gaurd
    if (error)
        return (<div>{`Error loading agents data. Error thrown : ${error}`}</div>)

    //loading empty results gaurd
    if (agentRegistry.size === 0)
        //Todo : add UI that indicates that no agents data in the sytem
        return (<div>{`No agents in system`}</div>)

    //Loading agents list
    return (
        <Fragment>
            <AgentsList/>
        </Fragment>
    )
}

export default observer(AgentsDashboard);
